import httpAdminClient from '@/plugins/httpAdminClient';

export default {
  getEntries(id, currentPage, state, list) {
    return httpAdminClient.get(`admin/compete/projects/${id}/entries?page=${currentPage}&per_page=30${state}${list}`);
  },
  moveHeight(id) {
    return httpAdminClient.post(`/admin/compete/entries/${id}/move_higher`);
  },
  moveLower(id) {
    return httpAdminClient.post(`/admin/compete/entries/${id}/move_lower`);
  },
  setPosition(id, positionId) {
    return httpAdminClient.post(`/admin/compete/entries/${id}/position`, { position: positionId });
  },
  getEntriesInfo(id) {
    return httpAdminClient.get(`/admin/compete/entries/${id}`);
  },
  getExperts(params = { page: 1, per_page: 1000 }) {
    return httpAdminClient.get('admin/experts', { params });
  },
  settingExperts(id, ids) {
    return httpAdminClient.patch(`admin/compete/entries/${id}`, { compete_entry: { expert_ids: ids } });
  },
  updata(id, value) {
    return httpAdminClient.patch(`admin/compete/entries/${id}`, { compete_entry: { ...value } });
  },
  passEntry(id) {
    return httpAdminClient.post(`/admin/compete/entries/${id}/apply`);
  },
  noPassEntry(id) {
    return httpAdminClient.post(`/admin/compete/entries/${id}/cancel`);
  },
  downlist(id) {
    return httpAdminClient.get(`admin/compete/projects/${id}/export`);
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/adminApis/compete/entriesApis.js